module.exports = __webpack_public_path__ + "img/votorantim.5be0cb29.png";